import common from '../../common';
import {translate, Text} from '../../utils';
import TutorialLevel1 from './TutorialLevel1';
import TutorialLevel2 from './TutorialLevel2';
import TutorialLevel3 from './TutorialLevel3';
import TutorialLevel4 from './TutorialLevel4';
import TutorialLevel6 from './TutorialLevel6';
import TutorialLevel7 from './TutorialLevel7';
import TutorialLevel9 from './TutorialLevel9';
import TutorialLevel10 from './TutorialLevel10';
import TutorialLevel12 from './TutorialLevel12';
import TutorialLevel14 from './TutorialLevel14';

export default class TutorialOverlay extends PIXI.Container {
	constructor(scene, commands) {
		super();

		this._finger = null;
		this._panel = null;
		this._scene = scene;
		this._commands = commands;
		this._activeTutorial = null;
		this._canUpdate = true;

		this.signals = {
			stageUpdate: new P3.utils.MiniSignal()
		};

		// TODO: better way to do this?
		this.Tutorials = {
			'0'  : TutorialLevel1,
			'1'  : TutorialLevel2,
			'2'  : TutorialLevel3,
			'3'  : TutorialLevel4,
			'5'  : TutorialLevel6,
			'6'  : TutorialLevel7,
			'8'  : TutorialLevel9,
			'9'  : TutorialLevel10,
			'11' : TutorialLevel12,
			'13' : TutorialLevel14
		};

		this.init();
	}

	init() {
		this._createPanel();

		if (common.levelSettings.tutorial === 'full') {
			this._finger = new PIXI.Sprite(P3.assets.texture('ui_help_hand'));
			this._finger.anchor.set(0.5);
			this._finger.visible = false;
			this._finger.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
			this.addChild(this._finger);
		}

		if (common.currentLevel in this.Tutorials) {
			this._activeTutorial = new this.Tutorials[common.currentLevel](this._finger, this._panel, this._scene, this._commands);
			this._activeTutorial.signals.update.add(this._onTutorialUpdate, this);
			this._activeTutorial.prepareCommands();
		}
	}

	_createPanel() {
		this._panel = new PIXI.Sprite(P3.assets.texture('game_tutorial_panel'));
		this._panel.anchor.set(0.5, 1);
		this._panel.visible = false;
		this._panel.position.set((common.STAGE_WIDTH * 0.5), common.STAGE_HEIGHT - 20);
		this.addChild(this._panel);

		this._panel.label = Text('', {font: '26px Ahkio Thin', align: 'left'});
		this._panel.label.tint = 0xFFFFFF;
		this._panel.label.maxWidth = this._panel.width - 130;
		this._panel.label.anchor.set(0);
		this._panel.label.position.set((this._panel.width * -0.5) + 70, -this._panel.height + 5);

		this._panel.addChild(this._panel.label);

		if (common.levelSettings.unlock.icon !== -1) {
			const alienFace = new PIXI.Sprite(P3.assets.texture(common.levelSettings.unlock.icon));
			alienFace.anchor.set(0.5);
			alienFace.scale.set(0.8);
			alienFace.position.set(this._panel.width * -0.5 + 30, -this._panel.height + 30);

			this._panel.addChild(alienFace);
		}

		this._panel.scale.set(1.2);
	}

	_onTutorialUpdate() {
		this.alignLabel();
	}

	start() {
		// TODO: make this read 'textonly' instead from levels.json
		if (![7, 12, 18].includes(common.currentLevel)) {
			common.focusOverlay.visible = true;
			this._finger.visible = true;
		} else {
			this._panel.label.text = translate(`GAME.TUTORIAL.STAGE${common.currentLevel + 1}`);
			this.alignLabel();
		}
		this._panel.visible = true;

		if (this._activeTutorial) {
			this._activeTutorial.play();
		}
	}

	/**
	 * This is probably the best solution for "dynamicly" sized text I can imagine
	 */
	alignLabel() {
		if (!this._panel) {
			return;
		}
		const text = this._panel.label.text;
		this._panel.label.destroy();

		this._panel.label = Text(text, {font: '26px Ahkio Thin', align: 'left'});
		this._panel.label.tint = 0xFFFFFF;
		this._panel.label.maxWidth = this._panel.width - 260;
		this._panel.label.anchor.set(0);
		this._panel.label.position.set(this._panel.texture.width * -0.5 + 70, -this._panel.texture.height + 5);
		this._panel.addChild(this._panel.label);

		if (this._panel.label.height > this._panel.texture.height - 20) {
			this._panel.label.destroy();

			this._panel.label = Text(text, {font: '20px Ahkio Thin', align: 'left'});
			this._panel.label.tint = 0xFFFFFF;
			this._panel.label.maxWidth = this._panel.width - 260;
			this._panel.label.anchor.set(0);
			this._panel.label.position.set(this._panel.texture.width * -0.5 + 70, -this._panel.texture.height + 5);
			this._panel.addChild(this._panel.label);
		}
	}

	stop() {
		if (this._activeTutorial) {
			this._activeTutorial.destroy();
		}

		this._canUpdate = false;
		this.tweenOutTutorial();
	}

	update() {
		if (!this._canUpdate || !this._activeTutorial) {
			return;
		}

		this._activeTutorial.update();
	}

	tweenOutTutorial() {
		if (common.focusOverlay) {
			new P3.utils.TWEEN.Tween(common.focusOverlay, this.tweens)
				.to({alpha: 0}, 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None)
				.start();
		}

		if (this._finger) {
			new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({alpha: 0}, 500)
				.easing(P3.utils.TWEEN.Easing.Quadratic.Out)
				.onComplete(() => {
					this._finger.visible = false;
				})
				.start();
		}

		if (this._panel) {
			new P3.utils.TWEEN.Tween(this._panel, this.tweens)
				.to({
					y: common.STAGE_HEIGHT + 500
				}, 1000)
				.easing(P3.utils.TWEEN.Easing.Back.Out)
				.onComplete(() => {
					this._panel.visible = false;
				})
				.start();
		}
	}

	updateTutorial(stage) {
		if (!this._activeTutorial) {
			return;
		}

		this._activeTutorial.stage = stage;
		this._activeTutorial.play();
		this.alignLabel();
	}

	destroy() {
		if (this._activeTutorial) {
			this._activeTutorial.destroy();
		}

		if (this._finger) {
			this._finger.destroy();
		}

		this._scene = null;

		this._panel.label.destroy();
		this._panel.destroy();
		this._panel = null;
		this._finger = null;

		P3.utils.destroyAllSignals(this.signals);

		super.destroy();
	}

	get stage() {
		return this._activeTutorial.stage;
	}

	set stage(v) {
		this._activeTutorial.stage = v;
	}

	get panel() {
		return this._panel;
	}

	set panel(v) {
		this._panel = v;
	}
}
